<template>
    <footer id="page-footer" class="page-footer">
        <div class="highlighted" v-if="footer.highlighted">
            <wpImage 
                v-if="footer.highlighted.img"
                :data="footer.highlighted.img" 
                class="highligted-img"
                size="extra_large"
                background
                lazy
            />
            <div class="img-overlay"></div>

            <div class="highlight-content main-content">
                <div class="inner-wrapper">
                    <h2 class="hl-title" v-html="footer.highlighted.title"></h2>
                    <p class="hl-title" v-html="footer.highlighted.description"></p>
                    <p class="highlight-link"><AcfLink :data="footer.highlighted.link" v-if="footer.highlighted.link"/></p>
                </div>
            </div>
        </div>
        <div class="footer-inner main-content">

            <div class="about" v-if="footer.about">
                <router-link to="/" class="logo-wrapper">
                    <wpImage 
                        v-if="logoColor"
                        :data="logoColor" 
                        class="page-logo"
                    />
                </router-link>
                <p v-html="footer.about"></p>
                <wpNavi location="footer-menu" />
            </div>
            <div class="contact" v-if="footer.contact">
                <div class="map" v-html="footer.map_embed"></div>
                <h4 v-html="footer.contact.heading"></h4>
                <p v-html="footer.contact.adresse"></p>
                <p class="phone">Telefon: <a :href="'tel:'+footer.contact.phone" v-html="footer.contact.phone"></a></p>
                <p class="email">E-post: <a :href="'mailto:'+footer.contact.email" v-html="footer.contact.email"></a></p>
            </div>
        </div>

        <div class="sub-footer main-content">
            <p class="copyright" v-html="'Opphavsrett '+new Date().getFullYear()+' '+footer.copyright"></p>
            <p>Levert av <a href="https://tankenbak.no" target="_blank">Tanken Bak</a></p>
        </div>

    </footer>
</template>

<script>

import wpImage from '@/components/elements/WpImage'
import wpNavi from '@/components/navigation/WpNavi'
import wpLink from '@/components/navigation/WpLink'
import AcfLink from '@/components/elements/AcfLink'

export default {
    name: 'theme-footer',
    data() {
        return {
            logoWhite: WPVUE.options.dark,
            logoColor: WPVUE.options.light,
            footer: WPVUE.options
        }
    },
    components: {
        wpNavi,
        wpImage,
        wpLink,
        AcfLink
    },
}

</script>